import React, { useEffect, useRef, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { trackGAEvent } from '../../utils/gaTracking';

import { TListingClient } from 'types/TListing';

type TCarValueCheckerAppProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

let CarValueChecker;

const CarValueCheckerApp = ({ environment }: TCarValueCheckerAppProps) => {
  const {
    experiments: { isCarValueCheckerControl, isCarValueCheckerEnabled },
  } = environment;
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isCarValueCheckerControl && !isCarValueCheckerEnabled) {
      return;
    }
    const elementRef = containerRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            trackGAEvent('CarValueChecker_Exposed');
            if (isCarValueCheckerEnabled) {
              (async () => {
                try {
                  CarValueChecker = (
                    await import(/* webpackChunkName: "carValueChecker" */ './components/CarValueChecker')
                  ).default;
                  setIsLoaded(true);
                } catch {}
              })();
            }
          }
        });
      },
      { rootMargin: '0px 0px 100px 0px' },
    );

    if (elementRef) {
      observer.observe(elementRef);
    }

    return () => {
      observer.disconnect();
    };
  }, [isCarValueCheckerControl, isCarValueCheckerEnabled]);

  return (
    <EnvironmentProvider value={environment}>
      <div ref={containerRef}>{isLoaded && <CarValueChecker />}</div>
    </EnvironmentProvider>
  );
};

export default CarValueCheckerApp;
